import React, {useState} from 'react';
import {observer} from "mobx-react";
import {PropositionBetsWidgetSectionTitle} from "./proposition-bets-widget.section-title";
import classNames from "classnames";
import styles from "../../styles/proposition-bets-widget.module.scss";
import {PropositionBetsWidgetSectionSeeMore} from "./proposition-bets-widget.section-see-more";
import {PropositionBetsWidgetRows} from "../row/proposition-bets-widget.rows";

export const PropositionBetsWidgetSection = observer(({controller, isPreview, bet, section}) => {
  const [fullDisplay, setFullDisplay] = useState(false);

  const {rows, firstDisplayRows, previewRows} = section;
  const currentRows = isPreview ? previewRows : (fullDisplay ? rows : firstDisplayRows);

  const titleProps = {
    controller,
    currentRows,
    section
  }

  const rowsProps = {
    controller,
    currentRows,
    bet
  }

  const buttonProps = {
    controller,
    isPreview,
    fullDisplay,
    section,
    bet,
    onClick: () => setFullDisplay(!fullDisplay)
  }

  return (
    section?.rows?.length > 0 ? <div className={classNames(styles.section)}>
      <PropositionBetsWidgetSectionTitle {...titleProps}/>
      <PropositionBetsWidgetRows {...rowsProps}/>
      <PropositionBetsWidgetSectionSeeMore {...buttonProps}/>
    </div> : null
  )
});
